import ChatService from './chat.service';
import { GroupChatViewObject, ChatMember, ChatMessageViewObject, ReactionType } from '@/types/apiServerContract';
import { ChatModule } from '@/store/modules/chat/chat.store';
import bus from '@/core/bus';
import { BusConstants } from '@/core/constants';

ChatService.addEvent('GroupChatCreated', (chat: GroupChatViewObject) => {
    ChatModule.AddGroupChat(chat);
});

ChatService.addEvent('GroupChatUpdated', (chat: GroupChatViewObject) => {
    ChatModule.UpdateGroupChat(chat);
});

ChatService.addEvent('GroupChatNameChanged', (groupId: string, name: string) => {
    ChatModule.GroupChatNameChanged({ id: groupId, name: name });
});

ChatService.addEvent('GroupChatImageChanged', (groupId: string, image: string) => {
    ChatModule.GroupChatImageChanged({ id: groupId, image: image });
});

ChatService.addEvent('GroupChatMemberJoined', (groupId: string, chatMember: ChatMember) => {
    ChatModule.AddChatMember({ id: groupId, member: chatMember });
});

ChatService.addEvent('GroupChatMemberLeft', (groupId: string, chatMember: ChatMember) => {
    ChatModule.RemoveChatMember({ id: groupId, member: chatMember });
});

ChatService.addEvent('GroupChatMemberConnected', (groupId: string, memberId: string) => {
    ChatModule.GroupChatMemberConnected({ groupId: groupId, memberId: memberId });
});

ChatService.addEvent('GroupChatMemberDisconnected', (groupId: string, memberId: string) => {
    ChatModule.GroupChatMemberDisconnected({ groupId: groupId, memberId: memberId });
});

ChatService.addEvent('GroupChatDisbanded', (groupId: string) => {
    bus.emit(BusConstants.GroupChatDisbanded, groupId);
    ChatModule.RemoveGroupChat(groupId);
});

ChatService.addEvent('GroupChatMessageReceived', (groupId: string, message: ChatMessageViewObject) => {
    ChatModule.GroupChatMessageReceived(message);
});

ChatService.addEvent(
    'GroupChatMessageReaction',
    (groupId: string, messageId: string, author: string, authorName: string, type: ReactionType, active: boolean) => {
        ChatModule.GroupChatMessageReaction({ messageId, author, authorName, type, active });
    }
);
